/*!
 * Example taken from:
 * https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */

import { getWindow } from './dom-utils';

export default function getParameterByName(name, url) {
  const href    = url || getWindow().location.href;
  const query   = name.replace(/[\[\]]/g, "\\$&");
  const regex   = new RegExp("[?&]" + query + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(href);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function addUTMParametersToDict(props) {
  props = props || {};
  const utm_source = getParameterByName('utm_source');
  const utm_campaign = getParameterByName('utm_campaign');
  const utm_medium = getParameterByName('utm_medium');
  const utm_term = getParameterByName('utm_term');
  const utm_content = getParameterByName('utm_content');

  if (utm_source){
    props.utm_source = utm_source;
  }
  if (utm_campaign){
    props.utm_campaign = utm_campaign;
  }
  if (utm_medium){
    props.utm_medium = utm_medium;
  }
  if (utm_term){
    props.utm_term = utm_term;
  }
  if (utm_content){
    props.utm_content = utm_content;
  }
  return props;
}
